<script>
export default {
    data() {
        return {
            step: 1,
        };
    },
    
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/BenefitsSlider.vue